import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './theme/global.css';

import BottomNav from './navigation/BottomNav';
import Splash from './screens/Splash';
import Onboarding from './screens/Onboarding';
import Login from './screens/Login';
import Signup from './screens/Signup';
import ProfileSetup from './screens/ProfileSetup';
import Discover from './screens/Discover';
import Explore from './screens/Explore';
import Likes from './screens/Likes';
import Messages from './screens/Messages';
import Chat from './screens/Chat';
import Profile from './screens/Profile';
import Settings from './screens/Settings';
import Premium from './screens/Premium';
import Safety from './screens/Safety';
import Notifications from './screens/Notifications';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#08080C' }}>
      <div style={{ width: 32, height: 32, borderRadius: '50%', border: '2.5px solid rgba(255,255,255,0.08)', borderTopColor: '#FF3D71', animation: 'spin 0.8s linear infinite' }} />
    </div>
  );
  return user ? children : <Navigate to="/login" />;
};

const Public = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#08080C' }}>
      <div style={{ width: 32, height: 32, borderRadius: '50%', border: '2.5px solid rgba(255,255,255,0.08)', borderTopColor: '#FF3D71', animation: 'spin 0.8s linear infinite' }} />
    </div>
  );
  return user ? <Navigate to="/discover" /> : children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ToastContainer position="bottom-center" autoClose={2500} theme="dark" toastStyle={{
          background: '#1A1A24', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 14,
          fontSize: 14, fontFamily: 'Inter',
        }} />
        <div className="app-shell">
          <Routes>
            <Route path="/" element={<Splash />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/login" element={<Public><Login /></Public>} />
            <Route path="/signup" element={<Public><Signup /></Public>} />
            <Route path="/profile-setup" element={<Protected><ProfileSetup /></Protected>} />
            <Route path="/discover" element={<Protected><Discover /></Protected>} />
            <Route path="/explore" element={<Protected><Explore /></Protected>} />
            <Route path="/likes" element={<Protected><Likes /></Protected>} />
            <Route path="/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/chat/:matchId" element={<Protected><Chat /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/premium" element={<Protected><Premium /></Protected>} />
            <Route path="/safety" element={<Protected><Safety /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <BottomNav />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
